import { render, staticRenderFns } from "./Accommodations.vue?vue&type=template&id=1c36b202&scoped=true"
import script from "./Accommodations.vue?vue&type=script&lang=js"
export * from "./Accommodations.vue?vue&type=script&lang=js"
import style0 from "./Accommodations.vue?vue&type=style&index=0&id=1c36b202&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c36b202",
  null
  
)

export default component.exports
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QSpinner,QIcon,QItemLabel});
